import { configData } from "./configData";
import { mapGetters } from "vuex";

export const submitData = {
  mixins: [configData],
  computed: {
    ...mapGetters({
      ticketData: 'tenants/ticketTypes/ticketData'
    })
  },
  methods: {
    onSubmit(event) {
      if (!this.validateData()) {
        event.preventDefault()
        return
      }
      const itemData = this.collectData()
      if (!itemData.id) {
        this.storeData(itemData)
      } else {
        this.updateItem(itemData)
      }
    },
    collectData() {
      let typeData = {
        id: this.ticketData.id,
        kiosk: !this.ticketData.kioskId ? this.kioskId : this.ticketData.kioskId,
        name: this.ticketData.name,
        description: this.ticketData.description,
        availability: this.ticketData.available_amount,
        pricing_rule: {
          entries: this.ticketData.entries,
          unit_price: this.ticketData.unit_price,
          type: this.ticketData.price_rule_type,
        },
        id_code_enabled: this.ticketData.id_code_enabled,
        icon: this.ticketData.icon,
        mode: this.ticketData.mode
      }

      if (this.ticketData.price_rule_type === this.PICKER) {
        let unitPrices = this.ticketData.unit_price;
        let unitTypes = this.ticketData.unit_type;

        if (!Array.isArray(unitPrices)) unitPrices = unitPrices ? [unitPrices] : [];
        if (!Array.isArray(unitTypes)) unitTypes = unitTypes ? [unitTypes] : [];

        let timePickers = [];

        const count = Math.max(unitPrices.length, unitTypes.length);
        for (let i = 0; i < count; i++) {
             if (unitPrices[i] && unitTypes[i]) {
                 timePickers.push({
                     unit_price: unitPrices[i],
                     unit_type: unitTypes[i]
                 });
             }
        }

        typeData.pricing_rule['time_pickers'] = timePickers;
        // We don't send unit_price and unit_type arrays anymore for PICKER
        delete typeData.pricing_rule['unit_price'];
        delete typeData.pricing_rule['unit_type'];

      } else if (this.ticketData.price_rule_type === this.FIXED) {
        typeData.pricing_rule['rules'] = this.ticketData.time_cost
      }

      return typeData
    },
    validateData() {
      const defaultLang = process.env.DEFAULT_LANGUAGE;
      let isValid = true;
      if (!this.ticketData.name[defaultLang]) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'name' })
        console.log('not validated default name')
        isValid = false
      }
      if (!this.ticketData.price_rule_type) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'price_rule_type' })
        console.log('not validated price_rule_type')
        isValid = false
      }
      if (this.ticketData.available_amount === 0) {
        this.$store.dispatch('tenants/ticketTypes/addError', { field: 'available_amount' })
        console.log('not validated available_amount')
        isValid = false
      }
      if (this.ticketData.price_rule_type === this.PICKER) {
        let hasPrice = false;
        if (Array.isArray(this.ticketData.unit_price)) {
             hasPrice = this.ticketData.unit_price.some(p => p);
        } else {
             hasPrice = !!this.ticketData.unit_price;
        }
        if (!hasPrice) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_price' })
          console.log('not validated unit_price')
          isValid = false
        }

        let hasType = false;
        if (Array.isArray(this.ticketData.unit_type)) {
             hasType = this.ticketData.unit_type.some(t => t);
        } else {
             hasType = !!this.ticketData.unit_type;
        }
        if (!hasType) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_type' })
          console.log('not validated unit_type')
          isValid = false
        }
      } else if (this.ticketData.price_rule_type === this.FIXED) {
        if (!this.ticketData.time_cost) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'time_cost' })
          console.log('not validated time_cost')
          isValid = false
        }
      } else if (this.ticketData.price_rule_type === this.FIXED_ENTRY) {
        if (!this.ticketData.entries) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'entries' })
          console.log('not validated entries')
          isValid = false
        }
        if (!this.ticketData.unit_price) {
          this.$store.dispatch('tenants/ticketTypes/addError', { field: 'unit_price' })
          console.log('not validated unit_price')
          isValid = false
        }
      }
      return isValid
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/tenants/ticket-types/mixins/submitData.js